// @generated by protoc-gen-es v2.9.0 with parameter "target=ts"
// @generated from file squareup/cash/moneta/core/models.proto (package squareup.cash.moneta.core, syntax proto2)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { TransferRail } from "./model/transfer_rail_pb";
import { file_squareup_cash_moneta_core_model_transfer_rail } from "./model/transfer_rail_pb";
import type { Money } from "../../../common/currency_pb";
import { file_squareup_common_currency } from "../../../common/currency_pb";
import { file_squareup_common_pii } from "../../../common/pii_pb";
import type { Instrument } from "../../../franklin/api/instrument_pb";
import { file_squareup_franklin_api_instrument } from "../../../franklin/api/instrument_pb";
import type { Region } from "../../../franklin/region_pb";
import { file_squareup_franklin_region } from "../../../franklin/region_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file squareup/cash/moneta/core/models.proto.
 */
export const file_squareup_cash_moneta_core_models: GenFile = /*@__PURE__*/
  fileDesc("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", [file_squareup_cash_moneta_core_model_transfer_rail, file_squareup_common_currency, file_squareup_common_pii, file_squareup_franklin_api_instrument, file_squareup_franklin_region]);

/**
 * @generated from message squareup.cash.moneta.core.StoredBalanceSnapshot
 */
export type StoredBalanceSnapshot = Message<"squareup.cash.moneta.core.StoredBalanceSnapshot"> & {
  /**
   * @generated from field: required string stored_value_token = 1;
   */
  storedValueToken: string;

  /**
   * @generated from field: required squareup.common.Money amount = 2;
   */
  amount?: Money;

  /**
   * @generated from field: required int64 version = 3;
   */
  version: bigint;
};

/**
 * Describes the message squareup.cash.moneta.core.StoredBalanceSnapshot.
 * Use `create(StoredBalanceSnapshotSchema)` to create a new message.
 */
export const StoredBalanceSnapshotSchema: GenMessage<StoredBalanceSnapshot> = /*@__PURE__*/
  messageDesc(file_squareup_cash_moneta_core_models, 0);

/**
 * A local version of RetryContext copied from cash-protos
 *
 * @generated from message squareup.cash.moneta.core.RetryContext
 */
export type RetryContext = Message<"squareup.cash.moneta.core.RetryContext"> & {
  /**
   * *
   * The timestamp that the payment/transfer was originally attempted to be created at.
   * This should correspond to the time that the original request is sent.
   *
   * @generated from field: optional int64 created_at = 1;
   */
  createdAt: bigint;

  /**
   * * The attempt number. Starts at 1 and increases with each attempt by the app. 
   *
   * @generated from field: optional int64 retry_attempt = 2;
   */
  retryAttempt: bigint;

  /**
   * *
   * True for a foreground retry (i.e. user-initiated refresh), false (the default) for a background
   * retry (i.e. app-scheduled retry). This distinction is used, for example, to prevent sending
   * notifications for foreground retries.
   *
   * @generated from field: optional bool is_foreground = 3;
   */
  isForeground: boolean;

  /**
   * * Information about errors received by the client in previous requests. 
   *
   * @generated from field: optional squareup.cash.moneta.core.RetryContext.ErrorContext error_context = 4;
   */
  errorContext?: RetryContext_ErrorContext;
};

/**
 * Describes the message squareup.cash.moneta.core.RetryContext.
 * Use `create(RetryContextSchema)` to create a new message.
 */
export const RetryContextSchema: GenMessage<RetryContext> = /*@__PURE__*/
  messageDesc(file_squareup_cash_moneta_core_models, 1);

/**
 * *
 * An "error" here is defined as an HTTP response where the status is one
 * of 403, 429, or 5xx.
 *
 * @generated from message squareup.cash.moneta.core.RetryContext.ErrorContext
 */
export type RetryContext_ErrorContext = Message<"squareup.cash.moneta.core.RetryContext.ErrorContext"> & {
  /**
   *
   * Client creation timestamp of the request that first received an error.
   * This is using the client's device clock.
   *
   * @generated from field: optional int64 first_request_created_at = 1;
   */
  firstRequestCreatedAt: bigint;

  /**
   * *
   * Server response timestamp of the request that first received an error.
   * This is using the HTTP response's "Date" header field, which may be null.
   *
   * @generated from field: optional int64 first_response_created_at = 2;
   */
  firstResponseCreatedAt: bigint;

  /**
   * * HTTP status code of the request that first received an error. 
   *
   * @generated from field: optional string first_error_response = 3;
   */
  firstErrorResponse: string;
};

/**
 * Describes the message squareup.cash.moneta.core.RetryContext.ErrorContext.
 * Use `create(RetryContext_ErrorContextSchema)` to create a new message.
 */
export const RetryContext_ErrorContextSchema: GenMessage<RetryContext_ErrorContext> = /*@__PURE__*/
  messageDesc(file_squareup_cash_moneta_core_models, 1, 0);

/**
 * @generated from message squareup.cash.moneta.core.RequestContext
 */
export type RequestContext = Message<"squareup.cash.moneta.core.RequestContext"> & {
  /**
   * @generated from field: optional string client_ip = 1;
   */
  clientIp: string;

  /**
   * @generated from field: optional string device_id = 2;
   */
  deviceId: string;

  /**
   * @generated from field: optional string timezone = 3;
   */
  timezone: string;

  /**
   * @generated from field: optional string user_agent = 4;
   */
  userAgent: string;

  /**
   * @generated from field: optional string installer_package = 5;
   */
  installerPackage: string;

  /**
   * @generated from field: optional string drm_id = 6;
   */
  drmId: string;

  /**
   * @generated from field: optional string tracking_cookie = 7;
   */
  trackingCookie: string;

  /**
   * @generated from field: optional string accept_language = 8;
   */
  acceptLanguage: string;

  /**
   * @generated from field: optional string browser_fingerprint = 9;
   */
  browserFingerprint: string;

  /**
   * @generated from field: optional string cash_client_scenario = 10;
   */
  cashClientScenario: string;

  /**
   * @generated from field: optional string cash_flow_token = 11;
   */
  cashFlowToken: string;

  /**
   * @generated from field: optional string network_operator = 12;
   */
  networkOperator: string;

  /**
   * @generated from field: optional string sim_info = 13;
   */
  simInfo: string;

  /**
   * @generated from field: optional string device_name = 14;
   */
  deviceName: string;

  /**
   * @generated from field: optional string connectivity = 15;
   */
  connectivity: string;

  /**
   * @generated from field: optional string do_not_track = 16;
   */
  doNotTrack: string;

  /**
   * @generated from field: optional string square_device_info = 17;
   */
  squareDeviceInfo: string;

  /**
   * @generated from field: optional string cell_location = 18;
   */
  cellLocation: string;

  /**
   * @generated from field: optional string robot_detection = 19;
   */
  robotDetection: string;

  /**
   * @generated from field: optional string host = 20;
   */
  host: string;

  /**
   * @generated from field: optional string device_advertising_id = 21;
   */
  deviceAdvertisingId: string;

  /**
   * @generated from field: optional string device_installation_id = 22;
   */
  deviceInstallationId: string;

  /**
   * @generated from field: optional string device_vendor_id = 23;
   */
  deviceVendorId: string;

  /**
   * @generated from field: optional string square_device_id = 24;
   */
  squareDeviceId: string;

  /**
   * @generated from field: optional squareup.cash.moneta.core.RetryContext retry_context = 25;
   */
  retryContext?: RetryContext;

  /**
   * The service initiating the Request to Moneta.
   *
   * @generated from field: optional squareup.cash.moneta.core.ClientService originating_calling_principle = 26;
   */
  originatingCallingPrinciple: ClientService;
};

/**
 * Describes the message squareup.cash.moneta.core.RequestContext.
 * Use `create(RequestContextSchema)` to create a new message.
 */
export const RequestContextSchema: GenMessage<RequestContext> = /*@__PURE__*/
  messageDesc(file_squareup_cash_moneta_core_models, 2);

/**
 * @generated from message squareup.cash.moneta.core.RiskCapabilities
 */
export type RiskCapabilities = Message<"squareup.cash.moneta.core.RiskCapabilities"> & {
  /**
   * @generated from field: repeated squareup.cash.moneta.core.RiskCapability capabilities = 1;
   */
  capabilities: RiskCapability[];
};

/**
 * Describes the message squareup.cash.moneta.core.RiskCapabilities.
 * Use `create(RiskCapabilitiesSchema)` to create a new message.
 */
export const RiskCapabilitiesSchema: GenMessage<RiskCapabilities> = /*@__PURE__*/
  messageDesc(file_squareup_cash_moneta_core_models, 3);

/**
 * @generated from message squareup.cash.moneta.core.PartialAuthorizationContext
 */
export type PartialAuthorizationContext = Message<"squareup.cash.moneta.core.PartialAuthorizationContext"> & {
  /**
   * Initial amount wanted by the customer
   *
   * @generated from field: optional squareup.common.Money initial_amount = 1;
   */
  initialAmount?: Money;

  /**
   * Maximum amount allowed by the issuer
   *
   * @generated from field: optional squareup.common.Money partial_amount_allowed = 2;
   */
  partialAmountAllowed?: Money;

  /**
   * Final amount selected by the customer
   *
   * @generated from field: optional squareup.common.Money final_amount = 3;
   */
  finalAmount?: Money;
};

/**
 * Describes the message squareup.cash.moneta.core.PartialAuthorizationContext.
 * Use `create(PartialAuthorizationContextSchema)` to create a new message.
 */
export const PartialAuthorizationContextSchema: GenMessage<PartialAuthorizationContext> = /*@__PURE__*/
  messageDesc(file_squareup_cash_moneta_core_models, 4);

/**
 * @generated from message squareup.cash.moneta.core.InstrumentOption
 */
export type InstrumentOption = Message<"squareup.cash.moneta.core.InstrumentOption"> & {
  /**
   * @generated from field: optional squareup.franklin.api.Instrument instrument = 1;
   */
  instrument?: Instrument;

  /**
   * @generated from field: optional squareup.cash.moneta.core.model.rails.TransferRail transfer_rail = 2;
   */
  transferRail: TransferRail;

  /**
   * @generated from field: optional squareup.cash.moneta.core.ProcessingMode processing_mode = 3;
   */
  processingMode: ProcessingMode;
};

/**
 * Describes the message squareup.cash.moneta.core.InstrumentOption.
 * Use `create(InstrumentOptionSchema)` to create a new message.
 */
export const InstrumentOptionSchema: GenMessage<InstrumentOption> = /*@__PURE__*/
  messageDesc(file_squareup_cash_moneta_core_models, 5);

/**
 * @generated from message squareup.cash.moneta.core.SourceInstrumentOptions
 */
export type SourceInstrumentOptions = Message<"squareup.cash.moneta.core.SourceInstrumentOptions"> & {
  /**
   * @generated from field: repeated squareup.cash.moneta.core.InstrumentOption options = 1;
   */
  options: InstrumentOption[];
};

/**
 * Describes the message squareup.cash.moneta.core.SourceInstrumentOptions.
 * Use `create(SourceInstrumentOptionsSchema)` to create a new message.
 */
export const SourceInstrumentOptionsSchema: GenMessage<SourceInstrumentOptions> = /*@__PURE__*/
  messageDesc(file_squareup_cash_moneta_core_models, 6);

/**
 * @generated from message squareup.cash.moneta.core.CustomerContext
 */
export type CustomerContext = Message<"squareup.cash.moneta.core.CustomerContext"> & {
  /**
   * @generated from field: optional squareup.franklin.Region region = 1;
   */
  region: Region;

  /**
   * @generated from field: optional bool is_sponsored = 2;
   */
  isSponsored: boolean;
};

/**
 * Describes the message squareup.cash.moneta.core.CustomerContext.
 * Use `create(CustomerContextSchema)` to create a new message.
 */
export const CustomerContextSchema: GenMessage<CustomerContext> = /*@__PURE__*/
  messageDesc(file_squareup_cash_moneta_core_models, 7);

/**
 * @generated from message squareup.cash.moneta.core.DigitalWalletAvailability
 */
export type DigitalWalletAvailability = Message<"squareup.cash.moneta.core.DigitalWalletAvailability"> & {
  /**
   * @generated from field: optional squareup.cash.moneta.core.DigitalWalletAvailability.Status status = 1;
   */
  status: DigitalWalletAvailability_Status;

  /**
   * @generated from field: optional squareup.cash.moneta.core.DigitalWalletType digital_wallet_type = 2;
   */
  digitalWalletType: DigitalWalletType;
};

/**
 * Describes the message squareup.cash.moneta.core.DigitalWalletAvailability.
 * Use `create(DigitalWalletAvailabilitySchema)` to create a new message.
 */
export const DigitalWalletAvailabilitySchema: GenMessage<DigitalWalletAvailability> = /*@__PURE__*/
  messageDesc(file_squareup_cash_moneta_core_models, 8);

/**
 * @generated from enum squareup.cash.moneta.core.DigitalWalletAvailability.Status
 */
export enum DigitalWalletAvailability_Status {
  /**
   * @generated from enum value: AVAILABLE = 0;
   */
  AVAILABLE = 0,

  /**
   * @generated from enum value: UNAVAILABLE = 1;
   */
  UNAVAILABLE = 1,
}

/**
 * Describes the enum squareup.cash.moneta.core.DigitalWalletAvailability.Status.
 */
export const DigitalWalletAvailability_StatusSchema: GenEnum<DigitalWalletAvailability_Status> = /*@__PURE__*/
  enumDesc(file_squareup_cash_moneta_core_models, 8, 0);

/**
 * @generated from message squareup.cash.moneta.core.Fee
 */
export type Fee = Message<"squareup.cash.moneta.core.Fee"> & {
  /**
   * @generated from field: optional squareup.common.Money amount = 1;
   */
  amount?: Money;

  /**
   * @generated from field: optional squareup.cash.moneta.core.FeeType type = 2;
   */
  type: FeeType;
};

/**
 * Describes the message squareup.cash.moneta.core.Fee.
 * Use `create(FeeSchema)` to create a new message.
 */
export const FeeSchema: GenMessage<Fee> = /*@__PURE__*/
  messageDesc(file_squareup_cash_moneta_core_models, 9);

/**
 * @generated from enum squareup.cash.moneta.core.TransferEntityState
 */
export enum TransferEntityState {
  /**
   * @generated from enum value: INITIATING = 0;
   */
  INITIATING = 0,

  /**
   * @generated from enum value: WAITING_ON_LIMITS = 1;
   */
  WAITING_ON_LIMITS = 1,

  /**
   * @generated from enum value: WAITING_ON_IDV = 2;
   */
  WAITING_ON_IDV = 2,

  /**
   * @generated from enum value: WAITING_ON_RISK = 3;
   */
  WAITING_ON_RISK = 3,

  /**
   * @generated from enum value: WAITING_ON_ASYNC_RISK_RESULT = 47;
   */
  WAITING_ON_ASYNC_RISK_RESULT = 47,

  /**
   * @generated from enum value: WAITING_ON_MONEY_TRANSFER = 4;
   */
  WAITING_ON_MONEY_TRANSFER = 4,

  /**
   * @generated from enum value: COMPLETED = 5;
   */
  COMPLETED = 5,

  /**
   * @generated from enum value: FAILED = 6;
   */
  FAILED = 6,

  /**
   * @generated from enum value: REVERSED = 7;
   */
  REVERSED = 7,

  /**
   * Replaced with WAITING_ON_MONEY_TRANSFER_FAILURE_FIX
   *
   * @generated from enum value: WAITING_ON_MONEY_TRANSFER_DECISION = 8 [deprecated = true];
   * @deprecated
   */
  WAITING_ON_MONEY_TRANSFER_DECISION = 8,

  /**
   * The cash-in was charged back and clawed back.
   *
   * @generated from enum value: CHARGED_BACK = 9;
   */
  CHARGED_BACK = 9,

  /**
   * The cash-in chargeback was reversed and the clawback was reimbursed.
   *
   * @generated from enum value: CLAWBACK_REIMBURSED = 43;
   */
  CLAWBACK_REIMBURSED = 43,

  /**
   * @generated from enum value: WAITING_ON_MONEY_TRANSFER_FAILURE_FIX = 10;
   */
  WAITING_ON_MONEY_TRANSFER_FAILURE_FIX = 10,

  /**
   * @generated from enum value: WAITING_ON_MONEY_TRANSFER_TO_PROCESS = 11;
   */
  WAITING_ON_MONEY_TRANSFER_TO_PROCESS = 11,

  /**
   * @generated from enum value: WAITING_ON_MONEY_TRANSFER_TO_SETTLE = 12;
   */
  WAITING_ON_MONEY_TRANSFER_TO_SETTLE = 12,

  /**
   * @generated from enum value: WAITING_ON_MANUAL_REVERSAL = 13;
   */
  WAITING_ON_MANUAL_REVERSAL = 13,

  /**
   * @generated from enum value: WAITING_ON_MANUAL_REVERSAL_SKIP_PUSH = 14;
   */
  WAITING_ON_MANUAL_REVERSAL_SKIP_PUSH = 14,

  /**
   * @generated from enum value: WAITING_ON_MANUAL_REVERSAL_DECISION = 15;
   */
  WAITING_ON_MANUAL_REVERSAL_DECISION = 15,

  /**
   * @generated from enum value: WAITING_ON_CUSTOMER_FOR_PARTIAL_AUTHORIZATION = 16;
   */
  WAITING_ON_CUSTOMER_FOR_PARTIAL_AUTHORIZATION = 16,

  /**
   * @generated from enum value: WAITING_ON_PARTIAL_AUTHORIZATION_TRANSFER = 17;
   */
  WAITING_ON_PARTIAL_AUTHORIZATION_TRANSFER = 17,

  /**
   * @generated from enum value: WAITING_ON_PARTIAL_AUTHORIZATION_REVERSAL = 18;
   */
  WAITING_ON_PARTIAL_AUTHORIZATION_REVERSAL = 18,

  /**
   * @generated from enum value: WAITING_ON_DOCUMENT_IDV = 19 [deprecated = true];
   * @deprecated
   */
  WAITING_ON_DOCUMENT_IDV = 19,

  /**
   * @generated from enum value: WAITING_ON_INSTRUMENT_SELECTION = 20;
   */
  WAITING_ON_INSTRUMENT_SELECTION = 20,

  /**
   * @generated from enum value: WAITING_ON_MONEY_TRANSFER_AUTHORIZATION = 21;
   */
  WAITING_ON_MONEY_TRANSFER_AUTHORIZATION = 21,

  /**
   * @generated from enum value: WAITING_ON_MONEY_TRANSFER_AUTHORIZATION_ASYNC_RESPONSE = 22;
   */
  WAITING_ON_MONEY_TRANSFER_AUTHORIZATION_ASYNC_RESPONSE = 22,

  /**
   * @generated from enum value: WAITING_ON_CAPTURE_POLICY_DECISION = 23;
   */
  WAITING_ON_CAPTURE_POLICY_DECISION = 23,

  /**
   * @generated from enum value: WAITING_ON_MONEY_TRANSFER_CAPTURE = 24;
   */
  WAITING_ON_MONEY_TRANSFER_CAPTURE = 24,

  /**
   * @generated from enum value: WAITING_ON_MONEY_TRANSFER_CAPTURE_ASYNC_RESPONSE = 25;
   */
  WAITING_ON_MONEY_TRANSFER_CAPTURE_ASYNC_RESPONSE = 25,

  /**
   * @generated from enum value: WAITING_ON_AUTHORIZATION_REVERSAL = 26;
   */
  WAITING_ON_AUTHORIZATION_REVERSAL = 26,

  /**
   * @generated from enum value: AUTHORIZED_WAITING_CALLER_ACTION = 27;
   */
  AUTHORIZED_WAITING_CALLER_ACTION = 27,

  /**
   * @generated from enum value: WAITING_ON_AUTHORIZATION_REVERSAL_ASYNC_RESPONSE = 28;
   */
  WAITING_ON_AUTHORIZATION_REVERSAL_ASYNC_RESPONSE = 28,

  /**
   * @generated from enum value: WAITING_ON_EXTRA_AUTHENTICATION = 29;
   */
  WAITING_ON_EXTRA_AUTHENTICATION = 29,

  /**
   * @generated from enum value: WAITING_ON_MONEY_TRANSFER_AUTHORIZATION_UNBLOCK = 30;
   */
  WAITING_ON_MONEY_TRANSFER_AUTHORIZATION_UNBLOCK = 30,

  /**
   * @generated from enum value: WAITING_ON_TRANSFER_RAIL_DECISION = 31;
   */
  WAITING_ON_TRANSFER_RAIL_DECISION = 31,

  /**
   * @generated from enum value: WAITING_ON_RESERVE_LIMITS_USAGE = 32;
   */
  WAITING_ON_RESERVE_LIMITS_USAGE = 32,

  /**
   * @generated from enum value: PARTIALLY_AUTHORIZED_WAITING_CALLER_ACTION = 33;
   */
  PARTIALLY_AUTHORIZED_WAITING_CALLER_ACTION = 33,

  /**
   * @generated from enum value: WAITING_ON_INSTRUMENT_ACCESS_VERIFICATION = 34;
   */
  WAITING_ON_INSTRUMENT_ACCESS_VERIFICATION = 34,

  /**
   * @generated from enum value: WAITING_ON_MANUAL_REVERSAL_SKIP_PUSH_DECISION = 35;
   */
  WAITING_ON_MANUAL_REVERSAL_SKIP_PUSH_DECISION = 35,

  /**
   * @generated from enum value: WAITING_ON_MONEY_RECLAIM = 37;
   */
  WAITING_ON_MONEY_RECLAIM = 37,

  /**
   * @generated from enum value: WAITING_ON_MONEY_RECLAIM_ASYNC_RESPONSE = 38;
   */
  WAITING_ON_MONEY_RECLAIM_ASYNC_RESPONSE = 38,

  /**
   * @generated from enum value: WAITING_ON_ELIGIBILITY = 36;
   */
  WAITING_ON_ELIGIBILITY = 36,

  /**
   * @generated from enum value: WAITING_ON_THREE_DS_DATA_ONLY_AUTHENTICATION = 39;
   */
  WAITING_ON_THREE_DS_DATA_ONLY_AUTHENTICATION = 39,

  /**
   * @generated from enum value: POST_AUTH_INSTRUMENT_VALIDATION = 45;
   */
  POST_AUTH_INSTRUMENT_VALIDATION = 45,

  /**
   * @generated from enum value: POST_AUTH_WAITING_ON_LIMITS = 41;
   */
  POST_AUTH_WAITING_ON_LIMITS = 41,

  /**
   * @generated from enum value: POST_AUTH_WAITING_ON_RISK = 42;
   */
  POST_AUTH_WAITING_ON_RISK = 42,

  /**
   * *
   * Digital payments (wallets, qr payments) require a call to the network to get additional
   *  information about the instrument to be used, unlike card payments which have all the instrument
   * info upfront. This requires us to auth _before_ having all the instrument information in order
   * to get it from the network.
   *
   * @generated from enum value: WAITING_ON_PAYLOAD_AUTHORIZATION = 44;
   */
  WAITING_ON_PAYLOAD_AUTHORIZATION = 44,

  /**
   * @generated from enum value: WAITING_ON_PAYLOAD_AUTHORIZATION_ASYNC = 46;
   */
  WAITING_ON_PAYLOAD_AUTHORIZATION_ASYNC = 46,

  /**
   * For ACH cash ins that must be restricted (for buying bitcoin), moneta must add the restriction
   * before asking money-mover to push money to the restricted balance.
   *
   * @generated from enum value: WAITING_ON_RESTRICTION_ADDITION = 48;
   */
  WAITING_ON_RESTRICTION_ADDITION = 48,

  /**
   * State before transitioning to failure to give us another state to take action or ask the customer
   * to take action.
   *
   * @generated from enum value: EVALUATING_FAILURE = 49;
   */
  EVALUATING_FAILURE = 49,
}

/**
 * Describes the enum squareup.cash.moneta.core.TransferEntityState.
 */
export const TransferEntityStateSchema: GenEnum<TransferEntityState> = /*@__PURE__*/
  enumDesc(file_squareup_cash_moneta_core_models, 0);

/**
 * *
 * REMINDER: When adding a failure reason, we need to notify our partners, such as Mir, so that they
 * can update their code to correctly map the new failure reason.
 *
 * @generated from enum squareup.cash.moneta.core.FailureReason
 */
export enum FailureReason {
  /**
   * Prerequisites Failures
   *
   * @generated from enum value: RETRY_EXPIRED = 29;
   */
  RETRY_EXPIRED = 29,

  /**
   * @generated from enum value: RETRY_EXPIRED_AFTER_ERROR = 104;
   */
  RETRY_EXPIRED_AFTER_ERROR = 104,

  /**
   * @generated from enum value: INVOKE_DIGITAL_WALLET_PAYMENT_FAILURE = 125;
   */
  INVOKE_DIGITAL_WALLET_PAYMENT_FAILURE = 125,

  /**
   * @generated from enum value: PASSCODE_VERIFICATION_FAILURE = 106;
   */
  PASSCODE_VERIFICATION_FAILURE = 106,

  /**
   * @generated from enum value: IDV_FAILURE = 0;
   */
  IDV_FAILURE = 0,

  /**
   * Limits Check Failures
   *
   * @generated from enum value: UNKNOWN_LIMITS_FAILURE = 7;
   */
  UNKNOWN_LIMITS_FAILURE = 7,

  /**
   * @generated from enum value: TRANSACTION_AMOUNT_BELOW_MINIMUM = 1;
   */
  TRANSACTION_AMOUNT_BELOW_MINIMUM = 1,

  /**
   * @generated from enum value: TRANSACTION_AMOUNT_EXCEEDS_MAXIMUM = 2;
   */
  TRANSACTION_AMOUNT_EXCEEDS_MAXIMUM = 2,

  /**
   * @generated from enum value: WEEKLY_CUSTOMER_AMOUNT_EXCEEDED = 3 [deprecated = true];
   * @deprecated
   */
  WEEKLY_CUSTOMER_AMOUNT_EXCEEDED = 3,

  /**
   * @generated from enum value: MONTHLY_CUSTOMER_AMOUNT_EXCEEDED = 4 [deprecated = true];
   * @deprecated
   */
  MONTHLY_CUSTOMER_AMOUNT_EXCEEDED = 4,

  /**
   * @generated from enum value: WEEKLY_INSTRUMENT_AMOUNT_EXCEEDED = 5 [deprecated = true];
   * @deprecated
   */
  WEEKLY_INSTRUMENT_AMOUNT_EXCEEDED = 5,

  /**
   * @generated from enum value: MONTHLY_INSTRUMENT_AMOUNT_EXCEEDED = 6 [deprecated = true];
   * @deprecated
   */
  MONTHLY_INSTRUMENT_AMOUNT_EXCEEDED = 6,

  /**
   * @generated from enum value: CUSTOMER_DAILY_BANK_TRANSFER_LIMIT_EXCEEDED = 59;
   */
  CUSTOMER_DAILY_BANK_TRANSFER_LIMIT_EXCEEDED = 59,

  /**
   * @generated from enum value: CUSTOMER_DAILY_PREFUND_BANK_TRANSFER_LIMIT_EXCEEDED = 60;
   */
  CUSTOMER_DAILY_PREFUND_BANK_TRANSFER_LIMIT_EXCEEDED = 60,

  /**
   * @generated from enum value: CUSTOMER_DAILY_ACH_CASH_IN_LIMIT_EXCEEDED = 61;
   */
  CUSTOMER_DAILY_ACH_CASH_IN_LIMIT_EXCEEDED = 61,

  /**
   * @generated from enum value: CUSTOMER_WEEKLY_SENDING_LIMIT_EXCEEDED = 33;
   */
  CUSTOMER_WEEKLY_SENDING_LIMIT_EXCEEDED = 33,

  /**
   * @generated from enum value: CUSTOMER_WEEKLY_SENDING_PRO_LIMIT_EXCEEDED = 34;
   */
  CUSTOMER_WEEKLY_SENDING_PRO_LIMIT_EXCEEDED = 34,

  /**
   * @generated from enum value: CUSTOMER_WEEKLY_SENDING_XBORDER_AMOUNT_EXCEEDED = 35;
   */
  CUSTOMER_WEEKLY_SENDING_XBORDER_AMOUNT_EXCEEDED = 35,

  /**
   * @generated from enum value: CUSTOMER_WEEKLY_RECEIVING_AMOUNT_EXCEEDED = 36;
   */
  CUSTOMER_WEEKLY_RECEIVING_AMOUNT_EXCEEDED = 36,

  /**
   * @generated from enum value: CUSTOMER_WEEKLY_RECEIVING_XBORDER_AMOUNT_EXCEEDED = 37;
   */
  CUSTOMER_WEEKLY_RECEIVING_XBORDER_AMOUNT_EXCEEDED = 37,

  /**
   * @generated from enum value: CUSTOMER_MONTHLY_SENDING_LIMIT_EXCEEDED = 38;
   */
  CUSTOMER_MONTHLY_SENDING_LIMIT_EXCEEDED = 38,

  /**
   * @generated from enum value: CUSTOMER_MONTHLY_RECEIVING_LIMIT_EXCEEDED = 39;
   */
  CUSTOMER_MONTHLY_RECEIVING_LIMIT_EXCEEDED = 39,

  /**
   * @generated from enum value: CUSTOMER_MONTHLY_RECEIVING_COUNT_EXCEEDED = 48;
   */
  CUSTOMER_MONTHLY_RECEIVING_COUNT_EXCEEDED = 48,

  /**
   * @generated from enum value: CUSTOMER_MONTHLY_ACH_CASH_IN_LIMIT_EXCEEDED = 66;
   */
  CUSTOMER_MONTHLY_ACH_CASH_IN_LIMIT_EXCEEDED = 66,

  /**
   * @generated from enum value: CUSTOMER_MONTHLY_SPONSORED_CASH_IN_LIMIT_EXCEEDED = 69;
   */
  CUSTOMER_MONTHLY_SPONSORED_CASH_IN_LIMIT_EXCEEDED = 69,

  /**
   * @generated from enum value: CUSTOMER_WEEKLY_PREFUND_CASH_IN_LIMIT_EXCEEDED = 75;
   */
  CUSTOMER_WEEKLY_PREFUND_CASH_IN_LIMIT_EXCEEDED = 75,

  /**
   * @generated from enum value: CUSTOMER_WEEKLY_DEBIT_CASH_OUT = 72;
   */
  CUSTOMER_WEEKLY_DEBIT_CASH_OUT = 72,

  /**
   * @generated from enum value: CUSTOMER_WEEKLY_ACH_CASH_OUT = 73;
   */
  CUSTOMER_WEEKLY_ACH_CASH_OUT = 73,

  /**
   * @generated from enum value: CUSTOMER_WEEKLY_CASH_OUT = 77;
   */
  CUSTOMER_WEEKLY_CASH_OUT = 77,

  /**
   * @generated from enum value: CUSTOMER_WEEKLY_REMITTANCE_SEND = 79;
   */
  CUSTOMER_WEEKLY_REMITTANCE_SEND = 79,

  /**
   * @generated from enum value: CUSTOMER_MONTHLY_REMITTANCE_SEND = 80;
   */
  CUSTOMER_MONTHLY_REMITTANCE_SEND = 80,

  /**
   * @generated from enum value: CUSTOMER_DAILY_WIRES_TRANSFER = 81;
   */
  CUSTOMER_DAILY_WIRES_TRANSFER = 81,

  /**
   * @generated from enum value: CUSTOMER_WEEKLY_REMITTANCE_COUNT = 82;
   */
  CUSTOMER_WEEKLY_REMITTANCE_COUNT = 82,

  /**
   * @generated from enum value: CUSTOMER_OUTSTANDING_BILLS_LIMIT_EXCEEDED = 40;
   */
  CUSTOMER_OUTSTANDING_BILLS_LIMIT_EXCEEDED = 40,

  /**
   * @generated from enum value: CUSTOMER_BALANCE_LIMIT_EXCEEDED = 41;
   */
  CUSTOMER_BALANCE_LIMIT_EXCEEDED = 41,

  /**
   * @generated from enum value: INSTRUMENT_DAILY_ACH_CASH_IN_LIMIT_EXCEEDED = 64;
   */
  INSTRUMENT_DAILY_ACH_CASH_IN_LIMIT_EXCEEDED = 64,

  /**
   * @generated from enum value: INSTRUMENT_DAILY_PREFUND_BANK_TRANSFER_LIMIT_EXCEEDED = 65;
   */
  INSTRUMENT_DAILY_PREFUND_BANK_TRANSFER_LIMIT_EXCEEDED = 65,

  /**
   * @generated from enum value: INSTRUMENT_DAILY_BANK_TRANSFER_LIMIT_EXCEEDED = 62;
   */
  INSTRUMENT_DAILY_BANK_TRANSFER_LIMIT_EXCEEDED = 62,

  /**
   * @generated from enum value: INSTRUMENT_WEEKLY_SENDING_LIMIT_EXCEEDED = 42;
   */
  INSTRUMENT_WEEKLY_SENDING_LIMIT_EXCEEDED = 42,

  /**
   * @generated from enum value: INSTRUMENT_WEEKLY_SENDING_PRO_LIMIT_EXCEEDED = 43;
   */
  INSTRUMENT_WEEKLY_SENDING_PRO_LIMIT_EXCEEDED = 43,

  /**
   * @generated from enum value: INSTRUMENT_WEEKLY_RECEIVING_LIMIT_EXCEEDED = 44;
   */
  INSTRUMENT_WEEKLY_RECEIVING_LIMIT_EXCEEDED = 44,

  /**
   * @generated from enum value: INSTRUMENT_MONTHLY_SENDING_LIMIT_EXCEEDED = 45;
   */
  INSTRUMENT_MONTHLY_SENDING_LIMIT_EXCEEDED = 45,

  /**
   * @generated from enum value: INSTRUMENT_MONTHLY_RECEIVING_LIMIT_EXCEEDED = 46;
   */
  INSTRUMENT_MONTHLY_RECEIVING_LIMIT_EXCEEDED = 46,

  /**
   * @generated from enum value: INSTRUMENT_MONTHLY_ACH_CASH_IN_LIMIT_EXCEEDED = 67;
   */
  INSTRUMENT_MONTHLY_ACH_CASH_IN_LIMIT_EXCEEDED = 67,

  /**
   * @generated from enum value: INSTRUMENT_MONTHLY_SPONSORED_CASH_IN_LIMIT_EXCEEDED = 70;
   */
  INSTRUMENT_MONTHLY_SPONSORED_CASH_IN_LIMIT_EXCEEDED = 70,

  /**
   * @generated from enum value: INSTRUMENT_WEEKLY_PREFUND_CASH_IN_LIMIT_EXCEEDED = 76;
   */
  INSTRUMENT_WEEKLY_PREFUND_CASH_IN_LIMIT_EXCEEDED = 76,

  /**
   * @generated from enum value: PER_TRANSACTION_BANK_TRANSFER_LIMIT_EXCEEDED = 58;
   */
  PER_TRANSACTION_BANK_TRANSFER_LIMIT_EXCEEDED = 58,

  /**
   * @generated from enum value: PER_TRANSACTION_ACH_CASH_IN_LIMIT_EXCEEDED = 63;
   */
  PER_TRANSACTION_ACH_CASH_IN_LIMIT_EXCEEDED = 63,

  /**
   * @generated from enum value: PER_TRANSACTION_PREFUND_CASH_IN_LIMIT_EXCEEDED = 74;
   */
  PER_TRANSACTION_PREFUND_CASH_IN_LIMIT_EXCEEDED = 74,

  /**
   * @generated from enum value: PER_TRANSACTION_REMITTANCE_SEND = 78;
   */
  PER_TRANSACTION_REMITTANCE_SEND = 78,

  /**
   * @generated from enum value: CUSTOMER_ACTIVE_LINKED_ACCOUNTS_LIMIT_EXCEEDED = 83;
   */
  CUSTOMER_ACTIVE_LINKED_ACCOUNTS_LIMIT_EXCEEDED = 83,

  /**
   * @generated from enum value: CUSTOMER_DAILY_POOLS_CONTRIBUTION_COUNT_EXCEEDED = 110;
   */
  CUSTOMER_DAILY_POOLS_CONTRIBUTION_COUNT_EXCEEDED = 110,

  /**
   * @generated from enum value: CUSTOMER_WEEKLY_POOLS_CONTRIBUTION_COUNT_EXCEEDED = 111;
   */
  CUSTOMER_WEEKLY_POOLS_CONTRIBUTION_COUNT_EXCEEDED = 111,

  /**
   * @generated from enum value: INSTRUMENT_DAILY_POOLS_CONTRIBUTION_COUNT_EXCEEDED = 112;
   */
  INSTRUMENT_DAILY_POOLS_CONTRIBUTION_COUNT_EXCEEDED = 112,

  /**
   * @generated from enum value: INSTRUMENT_WEEKLY_POOLS_CONTRIBUTION_COUNT_EXCEEDED = 113;
   */
  INSTRUMENT_WEEKLY_POOLS_CONTRIBUTION_COUNT_EXCEEDED = 113,

  /**
   * Money Transfer Failures
   *
   * @generated from enum value: UNKNOWN_MONEY_TRANSFER_FAILURE = 8;
   */
  UNKNOWN_MONEY_TRANSFER_FAILURE = 8,

  /**
   *
   * UNSUPPORTED_INSTRUMENT means that we cannot attempt this cash in on this instrument type. For example, if
   * credit cards are not supported for this cash in type, but the preselected instrument is a credit card type. This is
   * a failure of the calling service to allow the wrong type through.
   *
   * @generated from enum value: UNSUPPORTED_INSTRUMENT = 9;
   */
  UNSUPPORTED_INSTRUMENT = 9,

  /**
   * @generated from enum value: INSUFFICIENT_FUNDS = 10;
   */
  INSUFFICIENT_FUNDS = 10,

  /**
   *
   * INVALID_INSTRUMENT indicates we attempted the cash in, but for whatever reason the instrument was unusable and the
   * customer should try another.
   *
   * @generated from enum value: INVALID_INSTRUMENT = 12;
   */
  INVALID_INSTRUMENT = 12,

  /**
   * @generated from enum value: INSTRUMENT_EXPIRED = 13;
   */
  INSTRUMENT_EXPIRED = 13,

  /**
   * @generated from enum value: INVALID_CVV_OR_EXPIRATION_DATE = 14;
   */
  INVALID_CVV_OR_EXPIRATION_DATE = 14,

  /**
   * @generated from enum value: TRANSFER_DECLINED = 15;
   */
  TRANSFER_DECLINED = 15,

  /**
   * @generated from enum value: INVALID_ROUTING_NUMBER = 16;
   */
  INVALID_ROUTING_NUMBER = 16,

  /**
   * @generated from enum value: MONEY_TRANSFER_SUSPECTED_FRAUD = 17;
   */
  MONEY_TRANSFER_SUSPECTED_FRAUD = 17,

  /**
   * @generated from enum value: ACCOUNT_FROZEN = 18;
   */
  ACCOUNT_FROZEN = 18,

  /**
   * @generated from enum value: INSTRUMENT_DISABLED = 19;
   */
  INSTRUMENT_DISABLED = 19,

  /**
   * @generated from enum value: UNSUPPORTED_CURRENCY = 20;
   */
  UNSUPPORTED_CURRENCY = 20,

  /**
   * @generated from enum value: MONEY_TRANSFER_OVER_LIMIT = 21;
   */
  MONEY_TRANSFER_OVER_LIMIT = 21,

  /**
   * @generated from enum value: UNSUPPORTED_COUNTRY = 22;
   */
  UNSUPPORTED_COUNTRY = 22,

  /**
   * @generated from enum value: RESTRICTED_CARD = 23;
   */
  RESTRICTED_CARD = 23,

  /**
   * @generated from enum value: TRANSACTION_NOT_PERMITTED = 24;
   */
  TRANSACTION_NOT_PERMITTED = 24,

  /**
   * @generated from enum value: OTHER_MONEY_TRANSFER_FAILURE = 25;
   */
  OTHER_MONEY_TRANSFER_FAILURE = 25,

  /**
   * @generated from enum value: CUSTOMER_CHARGEBACK = 26;
   */
  CUSTOMER_CHARGEBACK = 26,

  /**
   * @generated from enum value: DO_NOT_HONOR = 30;
   */
  DO_NOT_HONOR = 30,

  /**
   * @generated from enum value: MISSING_MONEY_TRANSFER_FAILURE = 31;
   */
  MISSING_MONEY_TRANSFER_FAILURE = 31,

  /**
   * @generated from enum value: CARD_LOST_OR_STOLEN = 32;
   */
  CARD_LOST_OR_STOLEN = 32,

  /**
   * @generated from enum value: INSTANT_ACH_DISABLED = 71;
   */
  INSTANT_ACH_DISABLED = 71,

  /**
   * @generated from enum value: BALANCE_REQUIRED = 99;
   */
  BALANCE_REQUIRED = 99,

  /**
   * @generated from enum value: INVALID_USE_OF_CASH_CARD = 115;
   */
  INVALID_USE_OF_CASH_CARD = 115,

  /**
   * @generated from enum value: INSTRUMENT_INCURS_ADDITIONAL_FEES = 116;
   */
  INSTRUMENT_INCURS_ADDITIONAL_FEES = 116,

  /**
   * @generated from enum value: CARD_TERMINATED = 117;
   */
  CARD_TERMINATED = 117,

  /**
   * @generated from enum value: PICK_UP_CARD = 118;
   */
  PICK_UP_CARD = 118,

  /**
   * @generated from enum value: INVALID_MERCHANT = 119;
   */
  INVALID_MERCHANT = 119,

  /**
   * @generated from enum value: REVOCATION_OF_AUTH = 120;
   */
  REVOCATION_OF_AUTH = 120,

  /**
   * @generated from enum value: ACCOUNT_DENYLISTED = 121;
   */
  ACCOUNT_DENYLISTED = 121,

  /**
   * @generated from enum value: INVALID_AMOUNT = 122;
   */
  INVALID_AMOUNT = 122,

  /**
   * *
   * Failure due to external payment services (e.g. visa, mastercard etc.) returning:
   * - code 15: No such issuer, or
   * - code 91: issuer or switch inoperative and STIP not applicable or not available for this
   *            transaction; Time-out when no stand-in; POS Check Service: Destination unavailable;
   *            Credit Voucher and Merchandise Return Authorizations: V.I.P. sent the transaction to
   *            the issuer, but the issuer was unavailable.
   *
   * @generated from enum value: FAILED_TO_REACH_ISSUER = 123;
   */
  FAILED_TO_REACH_ISSUER = 123,

  /**
   * Failure due to external payment services (e.g. visa, mastercard etc.) returning:
   * - code 19: Re-enter transaction
   *
   * @generated from enum value: REENTER_TRANSACTION = 124;
   */
  REENTER_TRANSACTION = 124,

  /**
   * Risk Check Failures
   *
   * @generated from enum value: RISK_DECLINED = 27;
   */
  RISK_DECLINED = 27,

  /**
   * @generated from enum value: UNKNOWN_RISK_FAILURE = 28;
   */
  UNKNOWN_RISK_FAILURE = 28,

  /**
   * @generated from enum value: GENERAL_RISK_ERROR = 50;
   */
  GENERAL_RISK_ERROR = 50,

  /**
   * @generated from enum value: RISK_INVALID_REQUEST = 51;
   */
  RISK_INVALID_REQUEST = 51,

  /**
   * @generated from enum value: RISK_EVALUATION_TIMEOUT = 52;
   */
  RISK_EVALUATION_TIMEOUT = 52,

  /**
   * @generated from enum value: PLAID_INVALID_ACCESS_TOKEN = 53;
   */
  PLAID_INVALID_ACCESS_TOKEN = 53,

  /**
   * @generated from enum value: PLAID_ITEM_LOGIN_REQUIRED = 54;
   */
  PLAID_ITEM_LOGIN_REQUIRED = 54,

  /**
   * @generated from enum value: PLAID_INVALID_ACCOUNT_ID = 128;
   */
  PLAID_INVALID_ACCOUNT_ID = 128,

  /**
   * @generated from enum value: PLAID_NO_ACCOUNTS = 129;
   */
  PLAID_NO_ACCOUNTS = 129,

  /**
   * @generated from enum value: PLAID_ITEM_NOT_FOUND = 130;
   */
  PLAID_ITEM_NOT_FOUND = 130,

  /**
   * @generated from enum value: PLAID_INSUFFICIENT_CREDENTIALS = 131;
   */
  PLAID_INSUFFICIENT_CREDENTIALS = 131,

  /**
   * @generated from enum value: PLAID_ITEM_NOT_SUPPORTED = 132;
   */
  PLAID_ITEM_NOT_SUPPORTED = 132,

  /**
   *
   * Name on bank account source instrument is different from cash account verified name. Declined due to risk.
   *
   * @generated from enum value: ACCOUNT_NAME_MISMATCH = 133;
   */
  ACCOUNT_NAME_MISMATCH = 133,

  /**
   *
   * Bank account source instrument has less money than the cash-in needs, declined due to risk.
   *
   * @generated from enum value: ACCOUNT_WOULD_NSF = 134;
   */
  ACCOUNT_WOULD_NSF = 134,

  /**
   *
   * Name on bank account source instrument is different from cash account verified name and also has less money than
   * the cash-in needs, declined due to risk.
   *
   * @generated from enum value: ACCOUNT_NAME_MISMATCH_AND_WOULD_NSF = 135;
   */
  ACCOUNT_NAME_MISMATCH_AND_WOULD_NSF = 135,

  /**
   * Async cash ins are marked as failed if blockers are returned
   *
   * @generated from enum value: ASYNC_CASH_IN_BLOCKED = 47;
   */
  ASYNC_CASH_IN_BLOCKED = 47,

  /**
   * @generated from enum value: ASYNC_CASH_IN_BLOCKED_AFTER_ERROR = 103;
   */
  ASYNC_CASH_IN_BLOCKED_AFTER_ERROR = 103,

  /**
   * Business logic rate limit
   *
   * @generated from enum value: RATE_LIMITED = 49;
   */
  RATE_LIMITED = 49,

  /**
   * Failure reason used when an oncaller has decided to manually fail this transfer e.g due to a
   * SEV.
   *
   * @generated from enum value: ONCALL_MANUAL_FAILURE = 56;
   */
  ONCALL_MANUAL_FAILURE = 56,

  /**
   * Instrument selection failure reasons
   *
   * @generated from enum value: MISSING_CUSTOMER_INSTRUMENTS = 55;
   */
  MISSING_CUSTOMER_INSTRUMENTS = 55,

  /**
   * @generated from enum value: NO_SOURCE_INSTRUMENT_SELECTED = 68;
   */
  NO_SOURCE_INSTRUMENT_SELECTED = 68,

  /**
   * Used for plasma failure reason metrics, will not appear in TransferEntity or CashInEvent
   *
   * @generated from enum value: SOURCE_INSTRUMENT_SELECTION_ALL_LIMITS_EXHAUSTED = 107;
   */
  SOURCE_INSTRUMENT_SELECTION_ALL_LIMITS_EXHAUSTED = 107,

  /**
   * Default when no failure reason is known
   *
   * @generated from enum value: MISSING_FAILURE_REASON = 86;
   */
  MISSING_FAILURE_REASON = 86,

  /**
   * Cancellation Reasons
   *
   * @generated from enum value: CUSTOMER_DECLINED_PARTIAL_AUTHORIZATION = 57;
   */
  CUSTOMER_DECLINED_PARTIAL_AUTHORIZATION = 57,

  /**
   * @generated from enum value: CANCELED_BY_CALLER = 87;
   */
  CANCELED_BY_CALLER = 87,

  /**
   * @generated from enum value: MANUAL_CANCELLATION = 88;
   */
  MANUAL_CANCELLATION = 88,

  /**
   * @generated from enum value: AUTOMATICALLY_CANCELED = 89;
   */
  AUTOMATICALLY_CANCELED = 89,

  /**
   * @generated from enum value: EXTRA_AUTHENTICATION_DISABLED = 90;
   */
  EXTRA_AUTHENTICATION_DISABLED = 90,

  /**
   * @generated from enum value: EXTRA_AUTHENTICATION_DATA_INVALID = 91;
   */
  EXTRA_AUTHENTICATION_DATA_INVALID = 91,

  /**
   * @generated from enum value: EXTRA_AUTHENTICATION_INVALID_APP_VERSION = 92;
   */
  EXTRA_AUTHENTICATION_INVALID_APP_VERSION = 92,

  /**
   * @generated from enum value: EXTRA_AUTHENTICATION_FAILED = 95;
   */
  EXTRA_AUTHENTICATION_FAILED = 95,

  /**
   * @generated from enum value: EXTRA_AUTHENTICATION_UNKNOWN_FAILURE = 96;
   */
  EXTRA_AUTHENTICATION_UNKNOWN_FAILURE = 96,

  /**
   * @generated from enum value: ELIGIBILITY_CHECK_FAILED = 98;
   */
  ELIGIBILITY_CHECK_FAILED = 98,

  /**
   * @generated from enum value: EXPIRED_WAITING_ON_IDV = 105;
   */
  EXPIRED_WAITING_ON_IDV = 105,

  /**
   * Microauth / instrument access verification failures
   *
   * @generated from enum value: INSTRUMENT_ACCESS_VERIFICATION_AUTH_DECLINED = 101;
   */
  INSTRUMENT_ACCESS_VERIFICATION_AUTH_DECLINED = 101,

  /**
   * @generated from enum value: INSTRUMENT_ACCESS_VERIFICATION_CUSTOMER_INELIGIBLE = 100;
   */
  INSTRUMENT_ACCESS_VERIFICATION_CUSTOMER_INELIGIBLE = 100,

  /**
   * @generated from enum value: INSTRUMENT_ACCESS_VERIFICATION_DECLINED_BY_CUSTOMER = 97;
   */
  INSTRUMENT_ACCESS_VERIFICATION_DECLINED_BY_CUSTOMER = 97,

  /**
   * @generated from enum value: INSTRUMENT_ACCESS_VERIFICATION_FAILED = 93;
   */
  INSTRUMENT_ACCESS_VERIFICATION_FAILED = 93,

  /**
   * @generated from enum value: INSTRUMENT_ACCESS_VERIFICATION_INSUFFICIENT_FUNDS = 102;
   */
  INSTRUMENT_ACCESS_VERIFICATION_INSUFFICIENT_FUNDS = 102,

  /**
   * @generated from enum value: INSTRUMENT_ACCESS_VERIFICATION_TIME_LIMIT_EXCEEDED = 94;
   */
  INSTRUMENT_ACCESS_VERIFICATION_TIME_LIMIT_EXCEEDED = 94,

  /**
   * Failure reason used when an automatic process has decided to fail this transfer
   * e.g. through the automated stuck management process
   *
   * @generated from enum value: AUTOMATIC_FAILURE = 108;
   */
  AUTOMATIC_FAILURE = 108,

  /**
   * *
   * Used to mean exactly a cash in that was cancelled per the Expiring auth policy while it had an unresolved
   * TransferAuthorizedPendingCallerActionHurdle.
   *
   * @generated from enum value: EXPIRED_PENDING_CALLER_ACTION = 109;
   */
  EXPIRED_PENDING_CALLER_ACTION = 109,

  /**
   * *
   * A failure which was caused by specifically creating the transfer in a cancelled state. This is useful in async
   * workflows where you know you want to cancel eventually, but you don't know if the transfer has been created yet.
   *
   * @generated from enum value: PREEMPTIVELY_CANCELED = 114;
   */
  PREEMPTIVELY_CANCELED = 114,

  /**
   * *
   * The addition was not added because of business logic, such as hitting a limit of restrictions
   * or a rate limit.
   *
   * @generated from enum value: RESTRICTION_ADDITION_FAILED = 126;
   */
  RESTRICTION_ADDITION_FAILED = 126,

  /**
   * *
   * The addition was not added because of an internal unexpected error.
   *
   * @generated from enum value: RESTRICTION_ADDITION_ERROR = 127;
   */
  RESTRICTION_ADDITION_ERROR = 127,

  /**
   * *
   * The preselected bank account is not a Plaid link and cannot be used to cash-in.
   *
   * @generated from enum value: PRESELECTED_BANK_ACCOUNT_NOT_ACTIVE_PLAID_LINK = 136;
   */
  PRESELECTED_BANK_ACCOUNT_NOT_ACTIVE_PLAID_LINK = 136,

  /**
   * *
   * The fee parameters provided for the transfer are invalid, either because the default enum was sent, or because the
   * fee currency doesnt match the amount currency.
   *
   * @generated from enum value: INVALID_FEE_PARAMETERS = 137;
   */
  INVALID_FEE_PARAMETERS = 137,
}

/**
 * Describes the enum squareup.cash.moneta.core.FailureReason.
 */
export const FailureReasonSchema: GenEnum<FailureReason> = /*@__PURE__*/
  enumDesc(file_squareup_cash_moneta_core_models, 1);

/**
 * deprecated in favor of TransferRail
 *
 * @generated from enum squareup.cash.moneta.core.TransferType
 */
export enum TransferType {
  /**
   * @generated from enum value: DEBIT = 0;
   */
  DEBIT = 0,

  /**
   * @generated from enum value: ACH = 1;
   */
  ACH = 1,
}

/**
 * Describes the enum squareup.cash.moneta.core.TransferType.
 */
export const TransferTypeSchema: GenEnum<TransferType> = /*@__PURE__*/
  enumDesc(file_squareup_cash_moneta_core_models, 2);

/**
 * @generated from enum squareup.cash.moneta.core.OwnerType
 */
export enum OwnerType {
  /**
   * @generated from enum value: CUSTOMER = 0;
   */
  CUSTOMER = 0,
}

/**
 * Describes the enum squareup.cash.moneta.core.OwnerType.
 */
export const OwnerTypeSchema: GenEnum<OwnerType> = /*@__PURE__*/
  enumDesc(file_squareup_cash_moneta_core_models, 3);

/**
 * @generated from enum squareup.cash.moneta.core.TransferDirection
 */
export enum TransferDirection {
  /**
   * @generated from enum value: INFLOW = 0;
   */
  INFLOW = 0,

  /**
   * @generated from enum value: OUTFLOW = 1;
   */
  OUTFLOW = 1,
}

/**
 * Describes the enum squareup.cash.moneta.core.TransferDirection.
 */
export const TransferDirectionSchema: GenEnum<TransferDirection> = /*@__PURE__*/
  enumDesc(file_squareup_cash_moneta_core_models, 4);

/**
 * Whether the funds are available in the target instrument immediately or after some time.
 *
 * @generated from enum squareup.cash.moneta.core.ProcessingMode
 */
export enum ProcessingMode {
  /**
   * @generated from enum value: SYNCHRONOUS = 0;
   */
  SYNCHRONOUS = 0,

  /**
   * @generated from enum value: ASYNCHRONOUS = 1;
   */
  ASYNCHRONOUS = 1,
}

/**
 * Describes the enum squareup.cash.moneta.core.ProcessingMode.
 */
export const ProcessingModeSchema: GenEnum<ProcessingMode> = /*@__PURE__*/
  enumDesc(file_squareup_cash_moneta_core_models, 5);

/**
 * @generated from enum squareup.cash.moneta.core.FundingReason
 */
export enum FundingReason {
  /**
   * @generated from enum value: MANUAL_CASH_IN = 0;
   */
  MANUAL_CASH_IN = 0,

  /**
   * @generated from enum value: AUTO_CASH_IN = 1;
   */
  AUTO_CASH_IN = 1,

  /**
   * @generated from enum value: STOCK_PURCHASE = 2;
   */
  STOCK_PURCHASE = 2,

  /**
   * @generated from enum value: CRYPTO_PURCHASE = 3;
   */
  CRYPTO_PURCHASE = 3,

  /**
   * @generated from enum value: LOAN_PAYMENT = 4;
   */
  LOAN_PAYMENT = 4,

  /**
   * @generated from enum value: AUTO_STOCK_PURCHASE = 5;
   */
  AUTO_STOCK_PURCHASE = 5,

  /**
   * @generated from enum value: AUTO_CRYPTO_PURCHASE = 6;
   */
  AUTO_CRYPTO_PURCHASE = 6,

  /**
   * @generated from enum value: MANUAL_SAVINGS_CASH_IN = 7;
   */
  MANUAL_SAVINGS_CASH_IN = 7,

  /**
   * @generated from enum value: CRYPTO_PURCHASE_CUSTOM = 8;
   */
  CRYPTO_PURCHASE_CUSTOM = 8,

  /**
   * @generated from enum value: P2P_PAYMENT = 9;
   */
  P2P_PAYMENT = 9,

  /**
   * @generated from enum value: AUTO_OVERDRAFT_PAYMENT = 10;
   */
  AUTO_OVERDRAFT_PAYMENT = 10,

  /**
   * @generated from enum value: MANUAL_OVERDRAFT_PAYMENT = 11;
   */
  MANUAL_OVERDRAFT_PAYMENT = 11,

  /**
   * @generated from enum value: BALANCE_BASED_ADD_CASH = 12;
   */
  BALANCE_BASED_ADD_CASH = 12,

  /**
   * @generated from enum value: REMITTANCE = 13;
   */
  REMITTANCE = 13,

  /**
   * @generated from enum value: BANKING_BILL_PAYMENT = 14;
   */
  BANKING_BILL_PAYMENT = 14,

  /**
   * @generated from enum value: MANUAL_LOAN_PAYMENT = 15;
   */
  MANUAL_LOAN_PAYMENT = 15,

  /**
   * @generated from enum value: POOL_OWNER_CONTRIBUTION = 16;
   */
  POOL_OWNER_CONTRIBUTION = 16,

  /**
   * @generated from enum value: P2P_POOL_CONTRIBUTION = 17;
   */
  P2P_POOL_CONTRIBUTION = 17,

  /**
   * @generated from enum value: P2P_OON_POOL_CONTRIBUTION = 18;
   */
  P2P_OON_POOL_CONTRIBUTION = 18,

  /**
   * @generated from enum value: AUTO_SAVINGS_TRANSFER = 19;
   */
  AUTO_SAVINGS_TRANSFER = 19,

  /**
   * @generated from enum value: CRYPTO_PAYMENT_AS_A_SERVICE = 20;
   */
  CRYPTO_PAYMENT_AS_A_SERVICE = 20,

  /**
   * @generated from enum value: P2P_OON_PAYMENT = 21;
   */
  P2P_OON_PAYMENT = 21,

  /**
   * @generated from enum value: STABLECOIN_PAYMENT = 22;
   */
  STABLECOIN_PAYMENT = 22,

  /**
   * Superstacking ("Bitcoin Auto Buy"): cash-in funding the auto-buy of BTC triggered by a bitcoin Lightning spend.
   * Distinct from AUTO_CRYPTO_PURCHASE so transfers can attribute these separately; downstream ledger category and
   * limits intentionally reuse the crypto-purchase mappings for V1 (see crypto-invest-flow SuperstackingService).
   *
   * @generated from enum value: SUPERSTACKING = 23;
   */
  SUPERSTACKING = 23,
}

/**
 * Describes the enum squareup.cash.moneta.core.FundingReason.
 */
export const FundingReasonSchema: GenEnum<FundingReason> = /*@__PURE__*/
  enumDesc(file_squareup_cash_moneta_core_models, 6);

/**
 * *
 * The service that is calling Moneta to initate the cash in.
 * Please also add the mapping in ClientServiceMapper.
 *
 * @generated from enum squareup.cash.moneta.core.ClientService
 */
export enum ClientService {
  /**
   * @generated from enum value: BBAC = 0;
   */
  BBAC = 0,

  /**
   * @generated from enum value: BLOCK_STABLE = 12;
   */
  BLOCK_STABLE = 12,

  /**
   * @generated from enum value: BTC_MOONGATE = 11;
   */
  BTC_MOONGATE = 11,

  /**
   * @generated from enum value: CASH_PROXY = 1;
   */
  CASH_PROXY = 1,

  /**
   * @generated from enum value: CRYPTO_INVEST_FLOW = 2;
   */
  CRYPTO_INVEST_FLOW = 2,

  /**
   * @generated from enum value: FRANKLIN = 3;
   */
  FRANKLIN = 3,

  /**
   * @generated from enum value: INVEST_FLOW = 4;
   */
  INVEST_FLOW = 4,

  /**
   * @generated from enum value: LOANSTAR = 5;
   */
  LOANSTAR = 5,

  /**
   * @generated from enum value: P2P_ENGINE = 6;
   */
  P2P_ENGINE = 6,

  /**
   * @generated from enum value: PIGGYBANK = 10;
   */
  PIGGYBANK = 10,

  /**
   * @generated from enum value: REPEATEDLY = 7;
   */
  REPEATEDLY = 7,

  /**
   * @generated from enum value: SHADOW = 9;
   */
  SHADOW = 9,

  /**
   * @generated from enum value: TOOLBOX = 8;
   */
  TOOLBOX = 8,
}

/**
 * Describes the enum squareup.cash.moneta.core.ClientService.
 */
export const ClientServiceSchema: GenEnum<ClientService> = /*@__PURE__*/
  enumDesc(file_squareup_cash_moneta_core_models, 7);

/**
 * @generated from enum squareup.cash.moneta.core.RiskCapability
 */
export enum RiskCapability {
  /**
   * @generated from enum value: PARTIAL_AUTHORIZATION = 1;
   */
  PARTIAL_AUTHORIZATION = 1,

  /**
   * @generated from enum value: CAN_OVERCOME_WITH_INSTRUMENT_VERIFICATION = 2;
   */
  CAN_OVERCOME_WITH_INSTRUMENT_VERIFICATION = 2,
}

/**
 * Describes the enum squareup.cash.moneta.core.RiskCapability.
 */
export const RiskCapabilitySchema: GenEnum<RiskCapability> = /*@__PURE__*/
  enumDesc(file_squareup_cash_moneta_core_models, 8);

/**
 * @generated from enum squareup.cash.moneta.core.DigitalWalletType
 */
export enum DigitalWalletType {
  /**
   * @generated from enum value: APPLE_PAY = 0;
   */
  APPLE_PAY = 0,

  /**
   * @generated from enum value: GOOGLE_PAY = 1;
   */
  GOOGLE_PAY = 1,
}

/**
 * Describes the enum squareup.cash.moneta.core.DigitalWalletType.
 */
export const DigitalWalletTypeSchema: GenEnum<DigitalWalletType> = /*@__PURE__*/
  enumDesc(file_squareup_cash_moneta_core_models, 9);

/**
 * @generated from enum squareup.cash.moneta.core.FeeType
 */
export enum FeeType {
  /**
   * @generated from enum value: UNKNOWN_FEE = 0;
   */
  UNKNOWN_FEE = 0,

  /**
   * @generated from enum value: CREDIT_CARD_FEE = 1;
   */
  CREDIT_CARD_FEE = 1,

  /**
   * @generated from enum value: POOLS_OON_FEE = 2;
   */
  POOLS_OON_FEE = 2,

  /**
   * Fee for out-of-network payments (e.g., OON Pay Links). Maps to Banklin OUT_OF_NETWORK_FEE.
   *
   * @generated from enum value: OUT_OF_NETWORK_FEE = 3;
   */
  OUT_OF_NETWORK_FEE = 3,
}

/**
 * Describes the enum squareup.cash.moneta.core.FeeType.
 */
export const FeeTypeSchema: GenEnum<FeeType> = /*@__PURE__*/
  enumDesc(file_squareup_cash_moneta_core_models, 10);

/**
 * @generated from enum squareup.cash.moneta.core.ExecutionMachineStateEvent
 */
export enum ExecutionMachineStateEvent {
  /**
   * @generated from enum value: AsyncMoneyTransfer = 0;
   */
  AsyncMoneyTransfer = 0,

  /**
   * @generated from enum value: AuthorizedPendingCallerAction = 1;
   */
  AuthorizedPendingCallerAction = 1,

  /**
   * @generated from enum value: PartiallyAuthorized = 2;
   */
  PartiallyAuthorized = 2,

  /**
   * @generated from enum value: HurdlesResolved = 3;
   */
  HurdlesResolved = 3,

  /**
   * @generated from enum value: ManualReversalFailedPartialAuthorizationRequested = 4;
   */
  ManualReversalFailedPartialAuthorizationRequested = 4,

  /**
   * @generated from enum value: ManualFailure = 5;
   */
  ManualFailure = 5,

  /**
   * INITIATING
   *
   * @generated from enum value: Initiated = 6;
   */
  Initiated = 6,

  /**
   * @generated from enum value: FailedInitiation = 7;
   */
  FailedInitiation = 7,

  /**
   * WAITING_ON_LIMITS
   *
   * @generated from enum value: LimitsBlocked = 8;
   */
  LimitsBlocked = 8,

  /**
   * @generated from enum value: LimitsSucceeded = 9;
   */
  LimitsSucceeded = 9,

  /**
   * @generated from enum value: LimitsAutoApproved = 85;
   */
  LimitsAutoApproved = 85,

  /**
   * @generated from enum value: LimitsSucceededForPrefunded = 10;
   */
  LimitsSucceededForPrefunded = 10,

  /**
   * IDV hurdle
   *
   * @generated from enum value: LimitsValidWithIdv = 11;
   */
  LimitsValidWithIdv = 11,

  /**
   * @generated from enum value: IdvSucceeded = 12;
   */
  IdvSucceeded = 12,

  /**
   * @generated from enum value: IdvFailed = 13;
   */
  IdvFailed = 13,

  /**
   * WAITING_ON_INSTRUMENT_SELECTION
   *
   * @generated from enum value: InstrumentSelectionError = 14;
   */
  InstrumentSelectionError = 14,

  /**
   * @generated from enum value: InstrumentSelected = 15;
   */
  InstrumentSelected = 15,

  /**
   * WAITING_ON_ELIGIBILITY
   *
   * @generated from enum value: EligibilityCheckFailed = 16;
   */
  EligibilityCheckFailed = 16,

  /**
   * @generated from enum value: EligibilityCheckSucceeded = 17;
   */
  EligibilityCheckSucceeded = 17,

  /**
   * WAITING_ON_RISK
   *
   * @generated from enum value: RiskCheckApproved = 18;
   */
  RiskCheckApproved = 18,

  /**
   * @generated from enum value: RiskCheckAutoApproved = 81;
   */
  RiskCheckAutoApproved = 81,

  /**
   * @generated from enum value: RiskCheckSkipped = 19;
   */
  RiskCheckSkipped = 19,

  /**
   * @generated from enum value: RiskCheckError = 20;
   */
  RiskCheckError = 20,

  /**
   * @generated from enum value: RiskCheckDeclined = 21;
   */
  RiskCheckDeclined = 21,

  /**
   * @generated from enum value: AsyncRiskKickedOff = 75;
   */
  AsyncRiskKickedOff = 75,

  /**
   * WAITING_ON_ASYNC_RISK_RESULT
   *
   * @generated from enum value: AsyncRiskCheckApproved = 76;
   */
  AsyncRiskCheckApproved = 76,

  /**
   * @generated from enum value: AsyncRiskCheckSkipped = 77;
   */
  AsyncRiskCheckSkipped = 77,

  /**
   * @generated from enum value: AsyncRiskCheckDeclined = 78;
   */
  AsyncRiskCheckDeclined = 78,

  /**
   * @generated from enum value: AsyncRiskCheckError = 79;
   */
  AsyncRiskCheckError = 79,

  /**
   * @generated from enum value: AsyncRiskCheckDeclinedMicroAuthRequired = 80;
   */
  AsyncRiskCheckDeclinedMicroAuthRequired = 80,

  /**
   * Micro-auth hurdle
   *
   * @generated from enum value: InstrumentAccessVerificationRequired = 22;
   */
  InstrumentAccessVerificationRequired = 22,

  /**
   * @generated from enum value: InstrumentAccessVerificationSucceeded = 23;
   */
  InstrumentAccessVerificationSucceeded = 23,

  /**
   * @generated from enum value: InstrumentAccessVerificationFailed = 24;
   */
  InstrumentAccessVerificationFailed = 24,

  /**
   * @generated from enum value: InstrumentAccessVerificationAutomaticallyFailed = 25;
   */
  InstrumentAccessVerificationAutomaticallyFailed = 25,

  /**
   * @generated from enum value: MicroAuthRequired = 74;
   */
  MicroAuthRequired = 74,

  /**
   * WAITING_ON_TRANSFER_RAIL_DECISION
   *
   * @generated from enum value: AchRailSelected = 27;
   */
  AchRailSelected = 27,

  /**
   * @generated from enum value: CreditRailSelected = 82;
   */
  CreditRailSelected = 82,

  /**
   * @generated from enum value: DebitRailSelected = 26;
   */
  DebitRailSelected = 26,

  /**
   * @generated from enum value: DebitRailSelectedSkipThreeDS = 83;
   */
  DebitRailSelectedSkipThreeDS = 83,

  /**
   * @generated from enum value: RfpRailSelected = 91;
   */
  RfpRailSelected = 91,

  /**
   * WAITING_ON_MONEY_TRANSFER
   *
   * @generated from enum value: MoneyTransferFailed = 28;
   */
  MoneyTransferFailed = 28,

  /**
   * @generated from enum value: MoneyTransferClawedBack = 29;
   */
  MoneyTransferClawedBack = 29,

  /**
   * @generated from enum value: MoneyTransferClawbackFailed = 30;
   */
  MoneyTransferClawbackFailed = 30,

  /**
   * @generated from enum value: MoneyTransferAuthorized = 31;
   */
  MoneyTransferAuthorized = 31,

  /**
   * @generated from enum value: MoneyTransferAuthorizationIsRecoverable = 32;
   */
  MoneyTransferAuthorizationIsRecoverable = 32,

  /**
   * @generated from enum value: MoneyTransferAuthorizationBelowMinimum = 33;
   */
  MoneyTransferAuthorizationBelowMinimum = 33,

  /**
   * @generated from enum value: MoneyTransferPartialAuthorizationAvailable = 34;
   */
  MoneyTransferPartialAuthorizationAvailable = 34,

  /**
   * @generated from enum value: MoneyTransferPartialAuthorizationBelowMinimum = 35;
   */
  MoneyTransferPartialAuthorizationBelowMinimum = 35,

  /**
   * @generated from enum value: MoneyReclaimIsRecoverable = 36;
   */
  MoneyReclaimIsRecoverable = 36,

  /**
   * @generated from enum value: ManualReversalSucceeded = 37;
   */
  ManualReversalSucceeded = 37,

  /**
   * @generated from enum value: ManualReversalFailed = 38;
   */
  ManualReversalFailed = 38,

  /**
   * @generated from enum value: ManualReversalIsRecoverable = 39;
   */
  ManualReversalIsRecoverable = 39,

  /**
   * @generated from enum value: ManualReversalRequested = 40;
   */
  ManualReversalRequested = 40,

  /**
   * @generated from enum value: MoneyTransferCaptured = 41;
   */
  MoneyTransferCaptured = 41,

  /**
   * @generated from enum value: MoneyTransferCaptureIsRecoverable = 42;
   */
  MoneyTransferCaptureIsRecoverable = 42,

  /**
   * @generated from enum value: MoneyTransferSucceeded = 43;
   */
  MoneyTransferSucceeded = 43,

  /**
   * @generated from enum value: MoneyTransferSucceededAsyncCapture = 84;
   */
  MoneyTransferSucceededAsyncCapture = 84,

  /**
   * @generated from enum value: MoneyTransferIsRecoverable = 44;
   */
  MoneyTransferIsRecoverable = 44,

  /**
   * @generated from enum value: MoneyTransferInitiated = 45;
   */
  MoneyTransferInitiated = 45,

  /**
   * @generated from enum value: MoneyTransferSentForProcessing = 46;
   */
  MoneyTransferSentForProcessing = 46,

  /**
   * @generated from enum value: TransferAuthorizationReversalAsync = 47;
   */
  TransferAuthorizationReversalAsync = 47,

  /**
   * @generated from enum value: TransferAuthorizationReversalSucceeded = 48;
   */
  TransferAuthorizationReversalSucceeded = 48,

  /**
   * @generated from enum value: ManualReversalSkipPushRequested = 49;
   */
  ManualReversalSkipPushRequested = 49,

  /**
   * @generated from enum value: ReclaimRequested = 50;
   */
  ReclaimRequested = 50,

  /**
   * WAITING_ON_CAPTURE_POLICY_DECISION
   *
   * @generated from enum value: AuthShouldWaitOnCallerAction = 51;
   */
  AuthShouldWaitOnCallerAction = 51,

  /**
   * @generated from enum value: AuthShouldCaptureImmediately = 52;
   */
  AuthShouldCaptureImmediately = 52,

  /**
   * WAITING_ON_EXTRA_AUTHENTICATION (old) TODO: Deprecate it
   *
   * @generated from enum value: WaitOnExtraAuthentication = 53;
   */
  WaitOnExtraAuthentication = 53,

  /**
   * 3ds hurdle (old) TODO: Deprecate it
   *
   * @generated from enum value: ExtraAuthenticationRequired = 54;
   */
  ExtraAuthenticationRequired = 54,

  /**
   * @generated from enum value: ExtraAuthenticationSucceeded = 55;
   */
  ExtraAuthenticationSucceeded = 55,

  /**
   * @generated from enum value: ExtraAuthenticationDataInvalid = 56;
   */
  ExtraAuthenticationDataInvalid = 56,

  /**
   * @generated from enum value: ExtraAuthenticationDisabled = 57;
   */
  ExtraAuthenticationDisabled = 57,

  /**
   * @generated from enum value: ExtraAuthenticationFailed = 58;
   */
  ExtraAuthenticationFailed = 58,

  /**
   * auth pending caller hurdle
   *
   * @generated from enum value: CallerRequestedCapture = 59;
   */
  CallerRequestedCapture = 59,

  /**
   * @generated from enum value: CallerRequestedCancel = 60;
   */
  CallerRequestedCancel = 60,

  /**
   * @generated from enum value: AutoCaptureRequested = 61;
   */
  AutoCaptureRequested = 61,

  /**
   * partial auth hurdle
   *
   * @generated from enum value: CustomerAcceptedPartialAuthorization = 62;
   */
  CustomerAcceptedPartialAuthorization = 62,

  /**
   * @generated from enum value: CustomerDeclinedPartialAuthorization = 63;
   */
  CustomerDeclinedPartialAuthorization = 63,

  /**
   * @generated from enum value: AutomaticallyCancelled = 64;
   */
  AutomaticallyCancelled = 64,

  /**
   * Money Transfer update should be ignored
   *
   * @generated from enum value: IgnoreMoneyTransferUpdate = 65;
   */
  IgnoreMoneyTransferUpdate = 65,

  /**
   * 3DS Data Only Hurdle
   *
   * @generated from enum value: ThreeDSDataOnlyAuthenticationSkipped = 66;
   */
  ThreeDSDataOnlyAuthenticationSkipped = 66,

  /**
   * @generated from enum value: ThreeDSDataOnlyAuthenticationRequired = 67;
   */
  ThreeDSDataOnlyAuthenticationRequired = 67,

  /**
   * @generated from enum value: ThreeDSDataOnlyAuthenticationEnded = 68;
   */
  ThreeDSDataOnlyAuthenticationEnded = 68,

  /**
   * @generated from enum value: ThreeDSDataOnlyAuthenticationAutoFailed = 69;
   */
  ThreeDSDataOnlyAuthenticationAutoFailed = 69,

  /**
   * Digital Wallet verification outcomes
   *
   * @generated from enum value: DigitalWalletInstrumentVerified = 70;
   */
  DigitalWalletInstrumentVerified = 70,

  /**
   * @generated from enum value: UnverifiableDigitalWalletInstrument = 71;
   */
  UnverifiableDigitalWalletInstrument = 71,

  /**
   * @generated from enum value: DigitalWalletInitialized = 73;
   */
  DigitalWalletInitialized = 73,

  /**
   * @generated from enum value: ClawbackReimbursed = 72;
   */
  ClawbackReimbursed = 72,

  /**
   * Restrictions state events
   *
   * @generated from enum value: RestrictionAdditionRequired = 86;
   */
  RestrictionAdditionRequired = 86,

  /**
   * @generated from enum value: RestrictionAdded = 87;
   */
  RestrictionAdded = 87,

  /**
   * @generated from enum value: RestrictionAdditionFailed = 88;
   */
  RestrictionAdditionFailed = 88,

  /**
   * Evaluating failure state events
   *
   * @generated from enum value: EvaluateFailureCompleted = 89;
   */
  EvaluateFailureCompleted = 89,

  /**
   * @generated from enum value: EvaluateFailureNoAction = 90;
   */
  EvaluateFailureNoAction = 90,
}

/**
 * Describes the enum squareup.cash.moneta.core.ExecutionMachineStateEvent.
 */
export const ExecutionMachineStateEventSchema: GenEnum<ExecutionMachineStateEvent> = /*@__PURE__*/
  enumDesc(file_squareup_cash_moneta_core_models, 11);

/**
 * @generated from enum squareup.cash.moneta.core.CaptureReason
 */
export enum CaptureReason {
  /**
   * * Captures that occur automatically immediately after the auth is approved 
   *
   * @generated from enum value: IMMEDIATE_AUTO = 0;
   */
  IMMEDIATE_AUTO = 0,

  /**
   * * Captures that occur automatically prior to the auth expiring per the expiringAuthPolicy 
   *
   * @generated from enum value: DELAYED_AUTO = 1;
   */
  DELAYED_AUTO = 1,

  /**
   * * Captures that occur at the caller's request 
   *
   * @generated from enum value: DELAYED_MANUAL = 2;
   */
  DELAYED_MANUAL = 2,
}

/**
 * Describes the enum squareup.cash.moneta.core.CaptureReason.
 */
export const CaptureReasonSchema: GenEnum<CaptureReason> = /*@__PURE__*/
  enumDesc(file_squareup_cash_moneta_core_models, 12);

